import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../context/AuthContext'

export default function ChangePassword() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({ password: '', confirm: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (formData.password !== formData.confirm) {
      setError('Passwords do not match')
      return
    }
    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    setLoading(true)
    setError(null)

    const { error } = await supabase.auth.updateUser({ password: formData.password })
    if (error) { setError(error.message); setLoading(false); return }

    const { data: supporter } = await supabase
      .from('supporters').select('role').eq('id', user.id).single()

    if (supporter?.role === 'club_admin') navigate('/admin')
    else if (supporter?.role === 'chapter_coordinator') navigate('/coordinator')
    else if (supporter?.role === 'super_admin') navigate('/superadmin')
    else navigate('/dashboard')
  }

  const inputClass = "bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 focus:border-green-600 text-gray-900 dark:text-white px-4 py-3 text-sm outline-none transition-colors w-full"
  const labelClass = "text-xs text-gray-500 uppercase tracking-widest font-semibold"

  return (
    <div className="min-h-screen bg-white dark:bg-black flex flex-col items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">

        <div className="flex items-center gap-3 mb-10">
          <img src="/Mufulira_Wanderers_logo.png" alt="DSMS" className="w-10 h-10 object-contain" />
          <span className="font-black text-gray-900 dark:text-white tracking-widest uppercase text-xl">DSMS</span>
        </div>

        <div className="mb-8">
          <div className="text-xs text-green-600 dark:text-green-400 uppercase tracking-widest font-semibold mb-2">
            First Time Login
          </div>
          <h1 className="text-2xl font-black uppercase tracking-tight text-gray-900 dark:text-white mb-2">
            Set Your Password
          </h1>
          <p className="text-gray-500 text-sm">
            Please set a new password to secure your account. You will not be able to access your portal until this is done.
          </p>
        </div>

        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-red-600 dark:text-red-400 px-4 py-3 text-sm mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className={labelClass}>New Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="At least 8 characters"
              required
              className={inputClass}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label className={labelClass}>Confirm Password</label>
            <input
              type="password"
              value={formData.confirm}
              onChange={(e) => setFormData({ ...formData, confirm: e.target.value })}
              placeholder="Repeat your new password"
              required
              className={inputClass}
            />
          </div>

          <div className="flex flex-col gap-1.5 px-1">
            {[
              { label: 'At least 8 characters', met: formData.password.length >= 8 },
              { label: 'Passwords match', met: formData.password === formData.confirm && formData.confirm.length > 0 },
            ].map((hint) => (
              <div key={hint.label} className="flex items-center gap-2">
                <div className={`w-3 h-3 rounded-full border ${hint.met ? 'bg-green-500 border-green-500' : 'border-gray-300 dark:border-white/20'}`} />
                <span className={`text-xs ${hint.met ? 'text-green-600 dark:text-green-400' : 'text-gray-400'}`}>
                  {hint.label}
                </span>
              </div>
            ))}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 disabled:bg-green-900 disabled:text-green-700 text-white py-4 font-bold uppercase tracking-widest text-sm transition-colors mt-2"
          >
            {loading ? 'Saving...' : 'Set Password & Continue'}
          </button>
        </form>
      </div>
    </div>
  )
}